(function() {
  'use strict';

  angular
    .module('audio.audioDirective', [])
    .directive('mfAudio', mfAudio);

  mfAudio.$inject = ['Sension', '$window', '$timeout'];

  function mfAudio(Sension, $window, $timeout) {
    return {
      link: function postLink(scope, audioElem, iAttrs) {
        var audioState;
        var audioControl;
        var states;
        var intervalId;

        scope.$watch('mediaState', function(newAudioState) {
          if (!newAudioState) return;
          audioState = newAudioState;
          states = audioState.states;

          setupAudio5JS();
        });

        scope.$watch('mediaControl', function(newAudioControl) {
          if (!newAudioControl) return;
          audioControl = newAudioControl;

          setupAudio5JS();
        });

        function setupAudio5JS() {
          if (!audioControl || !audioState) return;

          audioState.audioSrc = audioControl.slide.narrationPath;

          new $window.Audio5js({
            swf_path: ($window.mfConfig.cdnPath || '') + 'vendor/audio5js/swf/audio5js.swf',
            codecs: ['mp3'],
            throw_errors: false,
            format_time: false,
            ready: scope.onReady,
            error: scope.onError
          });
        }

        scope.$on('$destroy', function() {
          if (intervalId)
            clearInterval(intervalId);
        });

        intervalId = setInterval(function() {
          if (!scope.audio5jsPlayer) return;

          scope.calculateTrackProgress();
          if (!scope.audio5jsPlayer.playing) {
            $timeout(function() {
              if (audioState != null && audioState.state == states.playing) {
                audioState.state = states.paused;
              }
            });
          } else if (Sension.enabled()) {
            Sension.updateTimestamp(audioControl.getCurrentTime());
          }
        }, 500);
      }
    };
  }
})();
